import { ErrorMessage, Field, Form, Formik } from 'formik';
import React, { useContext, useEffect } from 'react'
import { FormattedMessage, useIntl } from 'react-intl';
import { TexTranslate } from '../../../translations/FlattenMessages';
import * as yup from "yup";
import { FormGroup } from 'react-bootstrap';
import './sass/recoverPassword.css';
import bcryptjs from "bcryptjs";

import { ShowMessage } from '../showMessage/ShowMessage';

import { Context } from '../../containers/context/Context';
import { useRecoverPassword } from '../../../hooks/useRecoverPassword';
import { PasswordField } from '../PasswordField/PasswordField';

const RecoverPassword = ({ handleChangeTab }) => {

    const intl = useIntl();
    const { user, app } = useContext(Context);
    const { sentChangePass, resultChangePass } = useRecoverPassword();

    const token = sessionStorage.getItem("token") || sessionStorage.getItem("userRedirect");

    const parseJWT = (token) => {
        const base64Url = token.split('.')[1];
        const base64 = base64Url.replace('-', '+').replace('_', '/');

        return JSON.parse(window.atob(base64));
    }

    const loginToken = token ? parseJWT(token) : {};

    const formSchema = yup.object({
        currentPass: yup.string().required(<FormattedMessage id={"changePass.current password required"} defaultMessage={"changePass.current password required"} />),
        newPass: yup.string().required(<FormattedMessage id={"changePass.New Password required"} defaultMessage={"changePass.New Password required"} />),
        confirmPass: yup.string().required(<FormattedMessage id={"changePass.Confirm Password required"} defaultMessage={"changePass.Confirm Password required"} />)
            .oneOf([yup.ref('newPass')], <FormattedMessage id={"changePass.Passwords must be the same"} defaultMessage={"changePass.Passwords must be the same"} />)

    });

    const handleChangePasswordMandatory = async (values, { setFieldValue, setSubmitting }) => {
        setSubmitting(true);
        try {
            debugger;
            // eslint-disable-next-line no-useless-escape
            const pattern = /^(?=.*[0-9])(?=.*[a-z\u00f1\u00d1])(?=.*[A-Z\u00f1\u00d1])(?=.*[`!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?~])([0-9a-zA-Z\u00f1\u00d1!:;"´.°|¬,´'=+¿¡¨¨[\]()/\-?_\\@#{}\$%\^\&*]{8,})$/;
            const username = values.username;
            const currentPassword = values.currentPass;
            const newPassword = values.newPass;
            const passwordConfirm = values.confirmPass;
            const passwordBcrypt = await bcryptjs.hash (newPassword, app.salt);
            const currentPasswordBcrypt = await bcryptjs.hash (currentPassword, app.salt);
            if (username !== "" && currentPassword !== "" && newPassword !== "" && passwordConfirm !== "") {

                if (newPassword !== passwordConfirm) {

                    ShowMessage(
                        {
                            title: TexTranslate(intl, "general.Warning", "general.Warning"),
                            message: TexTranslate(intl, "changePass.Passwords must be the same", "changePass.Passwords must be the same"),
                            typeMessage: "warning",
                            showCancelButton: false,
                            confirmButtonText: TexTranslate(intl, "general.Accept"),
                            callbackConfirm: () => {
                                setFieldValue('currentPass', "");
                                setFieldValue('newPass', "");
                                setFieldValue('confirmPass', "");
                            },
                            intl
                        }
                    );

                } else if (newPassword.match(pattern) === null || newPassword.match(pattern) === undefined) {

                    ShowMessage(
                        {
                            title: TexTranslate(intl, "general.Warning", "general.Warning"),
                            message: TexTranslate(intl, "changePass.For the correct entry of the new password, it must contain: At least 8 characters. - 1 Number. - One capital letter. - 1 Lowercase Letter. - 1 Special character.", "changePass.For the correct entry of the new password, it must contain: At least 8 characters. - 1 Number. - One capital letter. - 1 Lowercase Letter. - 1 Special character."),
                            typeMessage: "warning",
                            showCancelButton: false,
                            confirmButtonText: TexTranslate(intl, "general.Accept"),
                            callbackConfirm: () => {
                                setFieldValue('currentPass', "");
                                setFieldValue('newPass', "");
                                setFieldValue('confirmPass', "");
                            },
                            intl
                        }
                    );

                } else {
                    //setShowLoader(true);
                    const dataChangePass = {};
                    dataChangePass.newPass = passwordBcrypt;
                    dataChangePass.currentPass = currentPasswordBcrypt;
                    sentChangePass({ "data" : dataChangePass, app, user});
                }
            }

        } catch (e) {
            console.error(e);
            //setShowLoader(false);
        }

        setSubmitting(false);

    }

    useEffect(() => {

        //setShowLoader(false);

        if (resultChangePass?.success) {

            ShowMessage(
                {
                    title: TexTranslate(intl, "alert.Success!", "alert.Success!"),
                    message: TexTranslate(intl, "changePass.Your password was updated successfully, a notification has been sent to your email", "changePass.Your password was updated successfully, a notification has been sent to your email"),
                    typeMessage: "success",
                    confirmButtonText: TexTranslate(intl, "general.accept", "general"),
                    intl
                }
            );
            document.getElementById("formChangePass").reset();
            handleChangeTab('tab1');

        } else if (resultChangePass?.msg) {
            if (resultChangePass.msg === "currentPassError") {
                ShowMessage(
                    {
                        title: TexTranslate(intl, "general.Warning", "general.Warning"),
                        message: TexTranslate(intl, "changePass.The current password is incorrect, please try again.", "changePass.The current password is incorrect, please try again."),
                        typeMessage: "warning",
                        showCancelButton: false,
                        confirmButtonText: TexTranslate(intl, "general.Accept"),
                        intl
                    }
                );
                document.getElementById("formChangePass").reset();

            } else if (resultChangePass.msg === "equals") {
                ShowMessage(
                    {
                        title: TexTranslate(intl, "general.Warning", "general.Warning"),
                        message: TexTranslate(intl, "changePass.The current password you entered cannot be the same as the new password", "changePass.The current password you entered cannot be the same as the new password"),
                        typeMessage: "warning",
                        showCancelButton: false,
                        confirmButtonText: TexTranslate(intl, "general.Accept"),
                        intl
                    }
                );
                document.getElementById("formChangePass").reset();
            }else if (resultChangePass.msg === "oldPass") {
                ShowMessage(
                    {
                        title: TexTranslate(intl, "general.Warning", "general.Warning"),
                        message: TexTranslate(intl, "changePass.This password was previously entered, please enter a different password", "changePass.This password was previously entered, please enter a different password"),
                        typeMessage: "warning",
                        showCancelButton: false,
                        confirmButtonText: TexTranslate(intl, "general.Accept"),
                        intl
                    }
                );
                document.getElementById("formChangePass").reset();

            }else if (resultChangePass.msg === "currentPassRepeat") {
                ShowMessage(
                    {
                        title: TexTranslate(intl, "general.Warning", "general.Warning"),
                        message: TexTranslate(intl, "changePass.The password entered has been used before, please enter a new one.", "changePass.The password entered has been used before, please enter a new one."),
                        typeMessage: "warning",
                        showCancelButton: false,
                        confirmButtonText: TexTranslate(intl, "general.Accept"),
                        intl
                    }
                );
                document.getElementById("formChangePass").reset();

            } else {
                console.error(resultChangePass.msg);
                ShowMessage(
                    {
                        title: TexTranslate(intl, "general.Warning", "general.Warning"),
                        message: TexTranslate(intl, "changePass.An error occurred while trying to change the password, please try again", "changePass.An error occurred while trying to change the password, please try again"),
                        typeMessage: "warning",
                        showCancelButton: false,
                        confirmButtonText: TexTranslate(intl, "general.Accept"),
                        intl
                    }
                );
                document.getElementById("formChangePass").reset();
            }

        } else if (resultChangePass != null && !resultChangePass.success) {

            ShowMessage(
                {
                    title: TexTranslate(intl, "general.Warning", "general.Warning"),
                    message: TexTranslate(intl, "changePass.For the correct entry of the new password, it must contain: At least 8 characters. - 1 Number. - One capital letter. - 1 Lowercase Letter.", "changePass.For the correct entry of the new password, it must contain: At least 8 characters. - 1 Number. - One capital letter. - 1 Lowercase Letter."),
                    typeMessage: "warning",
                    showCancelButton: false,
                    confirmButtonText: TexTranslate(intl, "general.Accept"),
                    intl
                }
            );
            document.getElementById("formChangePass").reset();
        }

    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [resultChangePass])


    return (
        <div className="section-changepass">
            <div className="contendor">
                <div className="form">
                    <h3 className='text-center'>
                        <FormattedMessage id={"changePass.Password change"} defaultMessage={"changePass.Password change"} />
                    </h3>

                    <Formik
                        initialValues={{
                            username: loginToken.user_name ? loginToken.user_name : ""
                            , currentPass: "", newPass: "", confirmPass: "", captcha: ""
                        }}
                        validationSchema={formSchema}
                        onSubmit={handleChangePasswordMandatory}
                    >
                        {({ isSubmitting }) => (
                            <Form id='formChangePass'>

                                <PasswordField
                                    name="currentPass"
                                    placeholder={TexTranslate(intl, "changePass.currentPass", "changePass.currentPass")}
                                />

                                <PasswordField
                                    name="newPass"
                                    placeholder={TexTranslate(intl, "changePass.New Password", "changePass.New Password")} 
                                    maxLength={50} 
                                    size={50}
                                />

                                <PasswordField
                                    name="confirmPass"
                                    placeholder={TexTranslate(intl, "changePass.Confirm Password", "changePass.Confirm Password")} 
                                    maxLength={50} 
                                    size={50}
                                />

                                <button disabled={isSubmitting} className="submitChangePass" type="submit" >
                                    <FormattedMessage id={"changePass.Change Password"} defaultMessage={"changePass.Change Password"} />
                                </button>

                                <FormGroup className="inputBox">
                                    <Field className="input" id="username" name="username" type="hidden"
                                        placeholder={TexTranslate(intl, "login.user", "login.user")} disabled={true} />
                                    <ErrorMessage
                                        name={"username"}
                                        component="div"
                                        className="field-error text-danger"
                                    />
                                </FormGroup>
                            </Form>
                        )}
                    </Formik>
                </div>
            </div>
        </div>
    )
}

export default RecoverPassword
